import React from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import { Snackbar, Box, Drawer, IconButton, Hidden, AppBar, Toolbar, Typography, Avatar, Container, MenuItem, Menu, Button, TablePagination, CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
//import MenuIcon from '@material-ui/icons/Menu';
import { FormattedMessage } from 'react-intl'
import logo from '../../assets/favicon.png';
import { IdentityActions, NotificationActions } from '../../store';
//import MainMenu from './MainMenu';

const drawerWidth = 210;

const styles = theme => ({
    grow: {
        display: 'flex',
        flexGrow: 1,
    },
    appBar: {
        marginLeft: drawerWidth,
        background: 'none',

        [theme.breakpoints.up('sm')]: {//Geater than 600px 
            width: `calc(100% - ${drawerWidth}px)`,
        },
    },
    //For menu bar items
    menuButton: {
        marginRight: theme.spacing(2),

        color: 'black',
        [theme.breakpoints.up('sm')]: {//Geater than 600px 
            display: 'none',
        },
    },
    title: {
        display: "none",

        [theme.breakpoints.up("sm")]: {//Geater than 600px
            display: "block"
        }
    },
    content: {
        flexGrow: 1,
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    drawerPaper: {
        width: drawerWidth,
    },
    logoContainer: {
        height: '60%',
        display: 'flex',
        color: 'black'
    },
    logo: {
        height: '40px',
    },
    startMessagetxt: {
        marginTop: '10px',
        marginLeft: '5px',
        fontSize: '15px'
    },
    toolbar: theme.mixins.toolbar,
    mainArea: {
        padding: '1em 1em 3em 1em'
    },
});

class EntryLayout extends React.Component {

    state = {
        mobileOpen: false,
        windowHeight: undefined,
        windowWidth: undefined
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
      //  if (this.props.isAuthenticated != true) {
      //      this.props.login();
      //  }

        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleDrawerToggle = () => {
        this.setState(state => ({ mobileOpen: !state.mobileOpen }));
    };

    handleResize = () => this.setState({
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth
    });

    handleAlertClose() {
        this.props.closeNotification();
    }

    onClickMenu = (url) => {
        this.props.history.push(`${url}`);
    }

    render() {
        //if (this.props.isAuthenticated != true) {
        //    return (<div></div>);
        //}

        const { classes, theme } = this.props;


        // メインコンテンツの高さ調整
        // ※ コンテンツの中でheight = 100%を機能させる
        var mainContentHeight = this.state.windowHeight - 64;
        if (this.refs.toolbar != null) {
            mainContentHeight = this.state.windowHeight - this.refs.toolbar.clientHeight;
        }

        return (
            <div className={classes.grow}>

                <Snackbar
                    open={this.props.alertOpen}
                    onClose={() => this.handleAlertClose()}
                    autoHideDuration={6000}>
                    <Alert severity={this.props.alertSeverity}>{this.props.alertMessage}</Alert>
                </Snackbar>

                <main className={classes.content}>
                    <div className={classes.toolbar} ref="toolbar" />

                    <Box height={mainContentHeight} className={classes.mainArea}>
                        {this.props.children}
                    </Box>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
//        isAuthenticated: state.Identity.isAuthenticated,
        alertOpen: state.Notification.open,
        alertMessage: state.Notification.message,
        alertSeverity: state.Notification.severity
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, IdentityActions, NotificationActions), dispatch)
}

export default compose(withStyles(styles, { withTheme: true }), withRouter, connect(
    mapStateToProps,
    mapDispatchToProps
))(EntryLayout);